import { render, staticRenderFns } from "./PatientDetailBasicInfo.vue?vue&type=template&id=5db73678&scoped=true&"
import script from "./PatientDetailBasicInfo.vue?vue&type=script&lang=ts&"
export * from "./PatientDetailBasicInfo.vue?vue&type=script&lang=ts&"
import style0 from "./PatientDetailBasicInfo.vue?vue&type=style&index=0&id=5db73678&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5db73678",
  null
  
)

export default component.exports